// src/js/reducers/index.js
import * as types from "../constants/action-types";

export default function fieldSchemaReducer(state = [], action) {
    switch (action.type) {
       
        case types.LOGOUT:
            return []
        case types.LOAD_FIELD_SCHEMA_SUCCESS:         
            return action.schema;      
        default:
            return state;
    };
};


